'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mutex = require('./mutex-63f09c81.cjs');



exports.createMutex = mutex.createMutex;
//# sourceMappingURL=mutex.cjs.map
